import { render, staticRenderFns } from "./ViewPreviousFile.vue?vue&type=template&id=2b781c2b&"
import script from "./ViewPreviousFile.vue?vue&type=script&lang=js&"
export * from "./ViewPreviousFile.vue?vue&type=script&lang=js&"
import style0 from "./ViewPreviousFile.vue?vue&type=style&index=0&id=2b781c2b&prod&lang=sass&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports